import React, { useState, useEffect } from "react";
import VehicleCard from "../../../vehicle-card/VehicleCard";
import BaseButtons from "../../../../../base-buttons/BaseButtons";
import { colors } from "../../../../../../../themes/Colors";
import { AddPopUp } from "./components";
import TextInputField from "../../../../../text-input-field/TextInputField";
import TextInputFieldArea from "../../../../../text-input-field/TextInputFieldArea";

const AccidentReport = ({
  data,
  setMessage,
  setPopUpTitle,
  setToastPop,
  setLoading,
}) => {
  const [popup, setPopUp] = useState(false);
  const [accidentList, setAccidentList] = useState(null);
  const getAccidentReportsHistory = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/vehicleAction/getAccidentReportList",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            vehicleIdentifier: data ? data._id : null,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setAccidentList(respnseData.accidentReportList);

        // setToastPop(true);
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (data) {
      getAccidentReportsHistory();
    }
  }, [data]);
  return (
    <div
      style={{
        width: "100%",
        // marginTop: 10,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflowY: "scroll",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          // paddingTop: 20,
          // paddingBottom: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 120,
          marginTop: 10,
        }}
      >
        <VehicleCard
          width={"100%"}
          // onManageClick={
          //   width > 899
          //     ? () => setManageVehicle(vehicle)
          //     : () => setVehicleManageView(vehicle)
          // }
          // type={type}
          licenceNr={data ? data.liscenseNumber : "loading"}
          // engineNr={vehicle.engineNumber}
          make={data ? data.make : "loading"}
          series={data ? data.series : "loading"}
          expireDate={"200 days"}
          // index={index + 1}
        />
      </div>
      <div
        style={{
          width: "100%",
          minHeight: 50,
          borderTopStyle: "solid",
          borderBottomStyle: "solid",
          marginTop: 20,
          borderColor: "#00000050",
          marginBottom: 10,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          fontSize: 16,
          color: "#00000080",
        }}
      >
        ACCIDENT REPORT
      </div>
      {accidentList
        ? accidentList.map((accident, index) => {
            return (
              <div
                key={index}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: index === 0 ? 10 : 0,
                  marginBottom: index === accidentList.length - 1 ? 80 : 0,
                }}
              >
                <div
                  style={{
                    width: "90%",
                    backgroundColor: colors.white,
                    WebkitBoxShadow: "0px 0px 2.5px 0px #00000050",
                    borderRadius: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    paddingBottom: 20,
                  }}
                >
                  <div style={{ width: "95%", marginTop: 10 }}>
                    <div
                      style={{
                        width: "100%",
                        marginTop: 15,
                        marginBottom: 15,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "80%",
                          textAlign: "left",
                          fontSize: 14,
                          fontWeight: "bold",
                        }}
                      >
                        Accident Information - vehicle
                      </div>
                    </div>
                    <TextInputField
                      labelTitle={"Incident Date"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={accident.incidentDate}
                      readOnly={true}
                    />
                    <TextInputField
                      labelTitle={"Incident Time"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={accident.incidentTime}
                      readOnly={true}
                    />

                    <TextInputField
                      labelTitle={"Incident Location"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={accident.incidentLocation}
                      readOnly={true}
                    />
                    <TextInputField
                      labelTitle={"SAPS case nr"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={accident.SapsCaseNr}
                      readOnly={true}
                    />

                    <TextInputField
                      labelTitle={"Vehicle liscense nr"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={accident.vehicleLiscenseNr}
                      readOnly={true}
                    />
                    <TextInputField
                      labelTitle={"Vehicle Make"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      readOnly={true}
                      value={accident.vehicleMake}
                    />
                    <TextInputField
                      labelTitle={"Vehicle Series"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      readOnly={true}
                      value={accident.vehicleSeries}
                    />
                    <TextInputField
                      labelTitle={"Vehicle Color"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={accident.vehicleColor}
                      readOnly={true}
                    />

                    <TextInputField
                      labelTitle={"Contact Person"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={accident.contactPerson}
                      readOnly={true}
                    />

                    <TextInputField
                      labelTitle={"Contact Number"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={accident.contactNumber}
                      readOnly={true}
                    />

                    <TextInputFieldArea
                      mini={true}
                      labelTitle={"ADDITIONAL INFO"}
                      height={100}
                      width={"100%"}
                      size={"80%"}
                      value={accident.additonalInfo}
                      readOnly={true}
                    />
                    <div
                      style={{
                        width: "100%",
                        marginTop: 15,
                        marginBottom: 15,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "80%",
                          textAlign: "left",
                          fontSize: 14,
                          fontWeight: "bold",
                        }}
                      >
                        Other vehicle
                      </div>
                    </div>
                    <TextInputField
                      labelTitle={"Vehicle liscense nr"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={accident.otherVehicleLiscenseNr}
                      readOnly={true}
                    />
                    <TextInputField
                      labelTitle={"Vehicle Make"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      readOnly={true}
                      value={accident.otherVehicleMake}
                    />
                    <TextInputField
                      labelTitle={"Vehicle Series"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      readOnly={true}
                      value={accident.otherVehicleSeries}
                    />
                    <TextInputField
                      labelTitle={"Vehicle Color"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={accident.otherVehicleColor}
                      readOnly={true}
                    />

                    <TextInputField
                      labelTitle={"Contact Person"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={accident.othgerContactPerson}
                      readOnly={true}
                    />

                    <TextInputField
                      labelTitle={"Contact Number"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={accident.otherContactNumber}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>
            );
          })
        : null}
      <AddPopUp
        display={popup}
        onCloseClick={() => setPopUp(false)}
        setLoading={setLoading}
        setMessage={setMessage}
        setToastPop={setToastPop}
        setPopUpTitle={setPopUpTitle}
        data={data}
        setPopUpDisplay={setPopUp}
      />
      <div
        style={{
          position: "fixed",
          bottom: 20,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: "100%",
        }}
      >
        <BaseButtons
          label={"ACCIDENT REPORT"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          width={"90%"}
          onClick={() => setPopUp(true)}
        />
      </div>
    </div>
  );
};

export default AccidentReport;
